import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-[#1A1612] min-h-screen">
      {/* SEO H1 - Visually hidden */}
      <h1 className="sr-only">Elena Mustakova — Interior Designer, Sofia & Milano</h1>
      
      {/* Photo and Bio Side by Side */}
      <div className="min-h-screen py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-start">
            {/* Left: Photo */}
            <div className="relative">
              <img
                src="https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/eh9rspld_IMG_3574.JPG"
                alt="Elena Mustakova - Interior Designer and Founder of Element Studio, Sofia and Milano"
                className="w-full h-auto"
              />
            </div>

            {/* Right: Text Content */}
            <div className="space-y-12">
              {/* Name and Role - Larger */}
              <div>
                <h1 className="text-6xl md:text-7xl lg:text-8xl font-light text-white mb-6">
                  {t('about.name')}
                </h1>
                <p className="text-2xl md:text-3xl font-light text-white">
                  {t('about.role')}
                </p>
              </div>

              {/* Bio text */}
              <div className="space-y-6">
                <p className="text-lg md:text-xl font-light text-white leading-relaxed">
                  Elena Mustakova trained in Milan — Bachelor's in Design at NABA, Master's at Politecnico di Milano — then spent eight years in the city, first at art direction studio DO Studio and then as interior designer at SAG80, working alongside Italy's most respected furniture houses.
                </p>
                
                <p className="text-lg md:text-xl font-light text-white leading-relaxed">
                  Back in Sofia, she led hospitality projects at Ligna Group before co-founding moustache studio — where the work started winning awards: Oborishte 63 (DIBLA, MUSE), Arcus Junior College (DIBLA, Building of the Year shortlist), and a shortlist at AHEAD London.
                </p>
                
                <p className="text-lg md:text-xl font-light text-white leading-relaxed">
                  In 2026, she founded Element. The decision was simple: it was time to be fully authentic to her vision.
                </p>
                
                <p className="text-lg md:text-xl font-light text-white leading-relaxed">
                  Element designs spaces that carry strong emotion. Concept-first, contextually grounded, with a clear personal signature — we work with people brave enough to provoke themselves, and with developers building the spaces people will actually remember.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
